import React, { useContext, useState } from 'react';

import { MobXProviderContext, observer } from 'mobx-react';

import { kebabCase } from 'lodash';

import '../../css/reports/ReportHideRowsModal.less';

import { SatCoreComponent, SatCoreRegister } from '../../SatCoreRegistry';

const ReportHideRowsModal = observer((props = {}) => {
  const {
    buttonKeyCancelLabel = 'cancel',
    buttonKeyConfirmLabel = 'hideRows',
    className = 'ReportHideRowsModal',
    closeOnDimmerClick = false,
    closeOnEscape = true,
    disableKeystroke = false,
    disableMove = false,
    disableResize = true,
    initHeight,
    initWidth,
    minHeight = 720,
    minWidth = 860,
    onOpen = () => {},
    onRequestClose,
    open: isOpen,
    overlay = 'medium',
    shouldExpandAllRowsOnInit,
    shouldSelectAllRowsOnInit,
    t, top = window.innerHeight / 6
  } = props;

  const {
    reportTableManager
  } = useContext(MobXProviderContext);

  const [isLoadingReportHideRowsModal, setIsLoadingReportHideRowsModal] = useState(false);

  const GenericModal = SatCoreComponent('GenericModal');
  const ReportTreeSelectionTable = SatCoreComponent('ReportTreeSelectionTable');

  const handleCloseReportHideRowsModal = async (_event, actionButtonData = {}) => {
    setIsLoadingReportHideRowsModal(true);

    // ensure we are also setting ReportTable to loading state (to allow data updates to take effect)
    reportTableManager.setLoadingTable(true);

    if (actionButtonData?.className?.includes?.(kebabCase(buttonKeyConfirmLabel))) {
      // user confirmed changes via 'Hide Rows' action button
      reportTableManager.setShouldUpdateReportTreeSelectionTableRows(true);

      props.onClose?.();

      // setTimeout(() => {
      setIsLoadingReportHideRowsModal(false);
      reportTableManager.setLoadingTable(false);
      // }, 500);
    } else {
      props.onClose?.();

      // setTimeout(() => {
      setIsLoadingReportHideRowsModal(false);
      reportTableManager.setLoadingTable(false);
      // }, 500);
    }
  };

  const reportReportTreeSelectionTable = () => {
    return (
      <ReportTreeSelectionTable
        shouldExpandAllRowsOnInit={shouldExpandAllRowsOnInit}
        shouldSelectAllRowsOnInit={shouldSelectAllRowsOnInit} />
    );
  };

  const headerMsg = t('hideRowsHeaderMsg');

  return (
    <GenericModal
      bodyMsg={reportReportTreeSelectionTable}
      buttonKeyCancelLabel={buttonKeyCancelLabel}
      buttonKeyConfirmLabel={buttonKeyConfirmLabel}
      className={className}
      closeOnDimmerClick={closeOnDimmerClick}
      closeOnEscape={closeOnEscape}
      disableKeystroke={disableKeystroke}
      disableMove={disableMove}
      disableResize={disableResize}
      headerMsg={headerMsg}
      initHeight={initHeight || minHeight}
      initWidth={initWidth || minWidth}
      isLoading={isLoadingReportHideRowsModal}
      isOpen={isOpen}
      onClose={handleCloseReportHideRowsModal}
      onOpen={onOpen}
      onRequestClose={onRequestClose}
      overlay={overlay}
      top={top} />
  );
});

export default ReportHideRowsModal;

SatCoreRegister('ReportHideRowsModal', ReportHideRowsModal);
